import { BusinessDestinationInfo } from "./BusinessDestinationInfo";
import { MemberType } from "./MemberType";

/**
 * 送り先情報
 */
export interface DestinationInfo {
    /**
     * 
     */
    type: MemberType

    /**
     * メンバータイプがguestの場合空文字
     * メンバータイプがmemberの場合メンバーIDが入る
     */
    id: string,

    /**
     * 名前
     */
    firstname: string,

    /**
     * 苗字
     */
    lastname: string,

    /**
     * 県
     */
    prefecture: string,
    /**
     * 市住所
     */
    city: string,

    /**
     * 市以降の住所
     */
    address: string,

    /**
     * 郵便番号
     */
    zipcode: string,

    /**
     * 電話番号
     * （電話番号またはメールアドレスは必須）
     */
    tel?: string,
    /**
     * 第2電話番号　（店員用電話番号）
     */
    tel2?: string,
    /**
     * 第3電話番号　（不使用）
     */
    tel3?: string,
    /**
     * メールアドレス
     * （電話番号またはメールアドレスは必須）
     */
    mailaddress?: string
}

export function createDefaultDestination(): BusinessDestinationInfo {
    return {
        id: "",
        address: "",
        city: "",
        companyName: "",
        firstname: "",
        lastname: "",
        prefecture: "",
        type: MemberType.Business,
        zipcode: "",
        tel: "",
    };
}